import React from 'react';
import { ScoreValue, ScoreText } from './styled.pill';
import { IScoreValues } from './../../../@types/pill';

export function Pill ({ value, keyValue }: IScoreValues) {
  return (
    <>
      <ScoreValue>{value}</ScoreValue>
      <ScoreText>{keyValue}</ScoreText>
    </>
  );
}
